import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Avatar } from '@/shared/components/Avatar';
import { ThemeToggle } from '@/shared/components/ThemeToggle';
import { ROTAS } from '@/shared/lib/rotas';
import { Button } from '@/shared/ui/button';

interface Props {
  titulo: string;
  nomeCompleto?: string | null;
  email?: string | null;
  crmv?: string | null;
  ufCrmv?: string | null;
  fotoUrl?: string | null;
  aoAbrirMenu: () => void;
}

export function Header({ titulo, nomeCompleto, email, crmv, ufCrmv, fotoUrl, aoAbrirMenu }: Props) {
  const primeiroNome = nomeCompleto?.trim().split(' ')[0];

  return (
    <header className="sticky top-0 z-30 bg-surface-raised border-b-2 border-brand/20">
      <div className="flex items-center justify-between px-6 py-3.5">
        <button
          onClick={aoAbrirMenu}
          className="lg:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          aria-label="Abrir menu"
        >
          <Menu className="w-5 h-5 text-muted-foreground" />
        </button>

        <div className="hidden lg:block">
          <h1 className="text-lg font-semibold text-foreground">{titulo}</h1>
        </div>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Link to={ROTAS.perfil}>
            <Button variant="ghost" className="flex items-center gap-2 hover:bg-muted rounded-lg px-2 py-1.5">
              <Avatar fotoUrl={fotoUrl} nome={nomeCompleto ?? email} />

              {crmv && (
                <div className="hidden lg:block text-left">
                  <p className="text-xs font-semibold text-foreground">
                    {primeiroNome ?? 'Médico Veterinário'}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    CRMV {crmv}
                    {ufCrmv ? `-${ufCrmv}` : ''}
                  </p>
                </div>
              )}
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
